<template>
    <a-layout :class="$style.root" v-if="alive" @click="isTimeOut">
        <div class="main">
            <a-layout-header v-if="hackReset">
                <Header />
            </a-layout-header>

            <a-layout-content>
                <router-view></router-view>
            </a-layout-content>
            <!--            <a-layout-footer>-->
            <!--                <Footer />-->
            <!--            </a-layout-footer>-->
        </div>

    </a-layout>
</template>

<script>

    import { mapActions } from 'vuex';
    import Header from './Header.vue';
    import Footer from './Footer.vue';
    import eventBus from '../utils/eventBus';
    import auth from '../utils/auth';

    export default {
        name: 'LayoutContainer',

        components: { Header, Footer },
        provide() {
            return {

                bus: eventBus,
                reload: this.reload,
            };
        },
        data() {
            return {
                hackReset: true,
                alive: true,
                lTime: new Date().getTime(), // 最后一次点击的时间
                ctTime: new Date().getTime(), // 当前时间
                tOut: 60 * 60 * 1000, // 超时时间10min
            };
        },

        mounted() {
            window.setInterval(this.tTime, 1000);
        },

        methods: {
            ...mapActions(['loginOut']),
            resets() {
                this.hackReset = false;
                this.$nextTick(() => {
                    this.hackReset = true;
                });
            },
            reload() {
                this.alive = false;
                this.$nextTick(() => {
                    this.alive = true;
                });
            },
            isTimeOut() {
                this.currentTime = new Date().getTime(); // 记录这次点击的时间
                if (this.currentTime - this.lastTime > this.timeOut) { // 判断上次最后一次点击的时间和这次点击的时间间隔是否大于30分钟
                    if (!auth.checkToken()) { // 如果是登录状态
                        auth.removeUserInfo();
                        auth.removeToken();
                    } else {
                        this.lastTime = new Date().getTime();
                    }
                } else {
                    this.lastTime = new Date().getTime(); // 如果在30分钟内点击，则把这次点击的时间记录覆盖掉之前存的最后一次点击的时间
                }
            },
            clicked() {
                this.lTime = new Date().getTime(); // 当界面被点击更新点击时间
            },
            tTime() {
                this.cTime = new Date().getTime();
                if (this.ctTime - this.lTime > this.tOut) {
                    if (!auth.checkToken()) { // 如果是登录状态
                        auth.removeUserInfo();
                        auth.removeToken();
                        this.loginOut();
                        this.$message.success('已退出');
                        this.$router.go(0);
                    } else {
                        this.lastTime = new Date().getTime();
                    }
                }
            },


        },
    };
</script>

<style lang="less" module>
@import "../styles/variables";

.root {
    color: #333;
    background-color: @main-bg-color !important;
    height: 100%;

    :global {
        .ant-layout-sider-trigger {
            background: #fff;
        }

        .logo {
            height: 80px;
            line-height: 80px;
            text-align: center;

            img {
                height: 50px;
                transition: height 0.2s ease;
            }
        }

        .ant-layout-header {
            height: 64px;
            padding: 0;
            line-height: 64px;
            background: #fff;
        }

        .ant-layout-footer {
            padding: 0;
            // color: rgba(0, 0, 0, 0.65);
            font-size: 14px;
            background: #fff;
        }

        .ant-layout-sider-collapsed {
            .logo img {
                height: 30px;
            }
        }

        .main {
            flex: 1;
            // padding: 20px;
            display: flex;
            flex-direction: column;
            //   overflow-y: auto;

            .vb {
                flex: 1;
                border-radius: 0 10px 10px 10px;

                .vb-content {
                    & > .page {
                        position: relative;
                        padding: 10px;
                        min-height: 100%;
                        display: flex;
                        flex-direction: column;
                    }
                }
            }
        }

        .video-box {

            box-shadow: 2px 2px 4px #eee;
        }

        .video-info {
            // width: 100%;
            display: flex;
            height: 26px;
            color: #8e8f91;
            display: flex;
            margin: 0 10px;
            justify-content: space-between;
        }

        .video-info .time {
            height: 26px;
            line-height: 26px;
            float: left;
        }

        .video-info .play {
            height: 26px;
            line-height: 26px;
            background: url(../assets/v-play.png) no-repeat left;
            padding-left: 20px;
            float: right;
            // margin-right: 10px;
        }

        .video-box:hover .video-info {
            // width: 260px;

        }

        .video-title {
            // width: 280px;
            height: 30px;
            line-height: 30px;
            margin-top: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
}
</style>
